import { Component, OnInit, Output, ViewChild , EventEmitter , ElementRef , ChangeDetectorRef,AfterViewInit } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { MatStepper } from '@angular/material/stepper';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { GooglePlacesAPI , Maps} from '../services/googlePlaces.service';

@Component({
  selector: 'app-add-vet',
  templateUrl: './add-vet.component.html',
  styleUrls: ['./add-vet.component.css']
})
export class AddVetComponent implements AfterViewInit {

  @Output() submitted = new EventEmitter()
  @ViewChild('searchGoogleAddressInput', { static: false }) public searchElementRef: ElementRef;

  data:any = {
    vet: {
      name: '',
      phone: '',
      displayAddress: ''
    }
  };
  errorMessage:string;

  constructor(private googlPlacesApi: GooglePlacesAPI,    private cdr: ChangeDetectorRef,) { 
    googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  ngAfterViewInit(): void {
    this.googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  ngOnInit(): void {
  }

  addVet() {
    this.errorMessage = '';
    if (!this.data.name || this.data.name == '' || !this.data.phone || this.data.phone == '' || this.data.phone.length < 10) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }
    this.submitted.emit(this.data);
  }

  googlePlacesSearch(){
    this.googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  initAutocompleteAddress(maps:Maps) {
    var autocomplete = new maps.places.Autocomplete(
      this.searchElementRef.nativeElement,{componentRestrictions: { country: ["us"] },fields: ["address_components", "geometry", "formatted_address"],
      types: ["address"],}
    );
    delete this.data.address;
    autocomplete.addListener('place_changed', () => {
      let place = autocomplete.getPlace();
      let address1 = "";
      let postcode = "";
      let locality = "";
      let country = "";
      let state = "";
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "locality":
            locality = component.long_name;
            break;
          case "administrative_area_level_1": {
            state = component.long_name;
            break;
          }
          case "country":
            country = component.long_name;
            break;
        }
      }
      this.data.address= {
        line1: address1,
        city: locality,
        state: state,
        zip: postcode,
        country: country,
        displayAddress: place.formatted_address
      }
      this.data.displayAddress = place.formatted_address;
      this.cdr.detectChanges();
    }); 
  }

}
